import { AirItinerary, AirPricingSolution, typeBaseAirSegment } from "./AirPricingSolutionProperties";
import { BookingInfoProperties, BookingPassengerInfoProperties } from "./BookingPassengerTicketIssuanceProperties";
import { BrandsNew, FareChangedProperties, FlightSchedulesNew, FlightSearchNewResponseProperties } from "./flight-results-response-properties";
import { FlightSearchProperties } from "./FlightSearchProperties";



export class SelectRBD {
  sector: string = "";
  rbd: string = "";
  supplier: string;
  sectorInfo: string[] = [];
  flightResultIndex = 0;
    
}

export class BaseFlightDetails {
  supplier: string = "";
  //pCC: string = "";
  agencyTotalPrice: string = "";
  agencyTaxAmount: string = "";
  agencyBaseFareAmount: string = "";
  id: number = 0;
  arrival: Arrival;
  departure: Departure;
  departureDate: string = "";
  marketingFlight: string = "";
  flightNumber: number = 0;
  airline: string = "";
  airlineLegalName: string = "";
  airlineLogo: string = "";
  equipment: string = "";
  operating: string = "";
  stopCount: number;
  totalPrice: string = "";
  totalTaxAmount: string = "";
  baseFareAmount: string = "";
  baseFareCurrency: string = "";
  dotRating: string = "";
  nonRefundable: boolean = false;
  elapsedTime: string = "";
  flightTime: string = "";
  eTicketable: boolean = false;
  flightStatused: number = 0;
  frequency: string = "";
  funnel: boolean = false;
  message: string = "";
  messageType: string = "";
  onTimePerformance: number = 0;
  smokingAllowed: boolean = false;
  totalMilesFlown: number = 0;
  trafficRestriction: string = "";

  seatsPending: string = "";
  fareBasis: string = "";
  cabinClass: string = "";
  pcc: string = "";
  vat: string = "";
  RBD: string = "";
  adultdiscount: number = 0;
  adultmarkup: number = 0;
  adultserviceCharges: number = 0;
  adultairlineCommision: number = 0;

  childdiscount: number = 0;
  childmarkup: number = 0;
  childserviceCharges: number = 0;
  childairlineCommision: number = 0;

  infdiscount: number = 0;
  infmarkup: number = 0;
  infserviceCharges: number = 0;
  infairlineCommision: number = 0;
  isRefreshAvailable: boolean = false;

  groupTicketId: number = 0;
  groupTicketPNR: string = "";
  groupTicketSupplierCode: string = "";
  groupTicketSupplierRemarks: string = "";

}

export class CombinationOfSubBrands {
  fromAirport: string = "";
  toAirport: string = "";
  brands: BrandsNew[] = [];
  brandsindex: boolean = false;
  selectedbrand: string = "";
  priceofselectedbrand: number = 0;
}





export class LegWiseFare {
  fromCity: string = "";
  departureDate: string = "";
  toCity: string = "";
  passengerType: number = 0;
  commission: number = 0;
  baseFareByPassenger: number = 0;
  totalTaxesFareByPassenger: number = 0;
  totalAmountByPassenger: number = 0;
}
    

export class PassengerFares {
  legwiseFare: LegWiseFare[] = [];
  agencyTotalPrice: string = "";
  agencyTaxAmount: string = "";
  agencyBaseFareAmount: string = "";
  agencyServiceFee: string = "";
  agencyDiscount: string = "";
  baseFareAmount: string = "";
  passengerType: string = "";
  currencyRate: number = 0;
  jazCRate: number = 0;
  taxAmount: string = "";
  totalAmount: string = "";
  serviceFee: string = "";
  count: number = 0;
  discount: string = "";
  markup: string = "";
  pxtype: string = "";

  agencyWiseFare: AgencyWiseFareCalculations[] = [];
  revenueIds: number[] = [];

  gruoupTicketServiceCharges: string = "";
  actualgruoupTicketServiceCharges: string = "";
 //20-jan-24
 serviceFeeValue:number=0;
 //end

  discountValue: number = 0;
}

export class modifyFlights {
  flightSearchResponse: FlightSearchNewResponseProperties;
  flightSearch: FlightSearchProperties;
  bookingInfo: BookingInfoProperties;
  isModified: boolean = false;
  retrievePNRResponse: string = "";
  token: string = "";
  modifyMoreData: string = "";
}


export enum CommissionType {
  baseFare = 1,
  totalFare = 2
}
export class AgencyWiseFareCalculations {
  public agency_BranchId: string;
  public serviceFee: number;

  public discount: number;

  public markup: number;

  public airlineCommision: number;
  public airlineCommisionType: string = "";
  public airlineCommissionPercentage: string = "";

  commissionType: CommissionType;
  airlineCommisionRevenueId: number;

  discountValue: number;
  markupValue: number;
  serviceFeeValue: number;
  airlineCommisionValue: number;
  CommissionOffer: number;
  CommissionOfferValue: number;
  CalculatedOn: string = "";
 WithHoldingTaxValue: number;
WithHoldingTaxPercentage: number;
}



export class FrontBaggageAllowanceType {
  passengerType: string = "";
  sector: string = "";
  cabinBaggage: string = "";
  checkinBaggage: string = "";
  baggageNote: string = "";
}
export class flightsectorIndex {
  prevflight: number = 0;
  prevsector: number = 0;
  prevbrand: number = 0;
}
export class FrontFareRules {
  PassengerType: string = "";
  ChangeFeePenalty: ChangeFee[] = [];
  CancellationFeePenalty: CancellationFee[] = [];
}
export class ChangeFee {
  typeChangeFee: string = "";
  percentageChangeFee: number = 0;
  penaltyType: string = "";
  fareRulesString: string = "";
  GeneralRulesString: string = "";

}
export class CancellationFee {
  typeChangeFee: string = "";
  percentageChangeFee: number = 0;
  penaltyType: string = "";
  fareRulesString: string = "";
  GeneralRulesString: string = "";
}


export class Departure {
  airport: string;
  city: string;
  country: string;
  state: string;
  terminal: string;
  time: string;
  date: string;
  depDate: string;
  sideTripIndicator: string;
  cityCode: string;
  airportCode: string;
  airlineCode: string;
  genericInd: string;
  globalInd: string;
  arrivalCityCode: string;
  arrivalAirportCode: string;
  infantFareConstructionCity: string;
  depEquipment: string;
  FlightNumber: string;
}

export class Arrival {
  airport: string;
  city: string;
  country: string;
  dateAdjustment: number;
  state: string;
  terminal: string;
  time: string;
  date: string;
  arrivDate: string;
  arivEquipment: string;
  FlightNumber: string;
}


export class FilterResults {
  oneStop: boolean = false;
  nonStop: boolean = false;
  twoStop: boolean = false;
  refundable: boolean = false;
  nonRefundable: boolean = false;
  providers: any[] = [];
  arrivelMorning: boolean = false;
  arrivelEarlyMorning: boolean = false;
  arrivelAfternoon: boolean = false;
  arrivelEvening: boolean = false;
  departureMorning: boolean = false;
  departureEarlyMorning: boolean = false;
  departureAfternoon: boolean = false;
  departureEvening: boolean = false;
}
export class BaggageDetails {
  baggageDetailsId: string = "";
  sector: string = "";
  checkInBaggage: string = "";
  cabinBaggage: string = "";
  meals: string = "";


}
export class BaggageWrapper {
  description: string = "";
  details: BaggageDetails[] = [];
}

export class BaggageAllowanceType {
  description1: string
  description2: string
  id: number = 0;
  pieceCount: number = 0;
  unit: string
  weight: number = 0;
  checkin: any;
  baggageDetails: any;
  sector: any;
}
export class ChangeRBDParamsGalileo {
  airItinerary = new AirItinerary();
  flightSearch: FlightSearchProperties;
  pricingSolution: any;
  rbdselect: SelectRBD[] = [];
  selectedFareBrand: string;
  selectedFareBrand1: string;
  selectedFareBrand2: string;
  supplier: string;
  brandselected: boolean = false;
  flightScheduleNew: FlightSchedulesNew;
  supplierpricingSolution: any;
  brandTotalPrice: string;
  bookingPCC: string;
  passengerFares: PassengerFares[] = [];
  jazeeraSegmentKeys: string[] = [];
  classOfService: string;
  fromAirport: any;
  toAirport: any;
  transactionIdentifier: any;
  fareChanged: FareChangedProperties;
  isFareChanged: boolean = false;
  isSpecialFare: boolean = false;
}

export class FlightSearchScreenRights {
  //bookAgent :  boolean = false;
  fareRules: boolean = false;
  quotations: boolean = false;
  bookingUser: boolean = false;
  bookingAgency: boolean = false;
  // reprice: boolean = false;

}

export class flyDetailLegDetails {
  PFID: number = 0;
  DepartureDate: string = "";
  Origin: string = "";
  Destination: string = "";
  FlightNum: string = "";
  International: boolean = true;
  ArrivalDate: string = "";
  FlightTime: number = 0;
  OperatingCarrier: string = "";
  MarketingCarrier: string = "";
  MarketingFlightNum: string = "";
  FromTerminal: string = "";
  ToTerminal: string = "";
  EQP: string = "";
  GeneralEQP: string = "";
}

/////////////////////////////////////////////////////////////////
//jazeera anxi

export class SSRData {
  ssrAvailabilityv2: SsrAvailabilityv2;
}

export class JourneyDetails {
  identifier: Identifier;
  origin: string;
  destination: string;
  departureDate: string;
}

export class JourneySsr {
  journeyKey: string;
  journeyDetails: JourneyDetails;
  ssrs: Ssr[];
}
export class Identifier {
  identifier: string;
  carrierCode: string;
  opSuffix: any;
}
export class Metadata {
  documentation_url: string;
}

export class LegDetails {
  identifier: Identifier;
  origin: string;
  destination: string;
  departureDate: string;
}

export class LegSsr {
  legKey: string;
  legDetails: LegDetails;
  ssrs: Ssr[];
}

export class PassengersAvailability {
  key: string;
  value: SSRValue;
}

export class AljazeeraSSRResponse {
  data: SSRData;
  metadata: Metadata;
}

export class SegmentDetails {
  identifier: Identifier;
  origin: string;
  destination: string;
  departureDate: string;
}

export class SegmentSsr {
  segmentKey: string;
  segmentDetails: SegmentDetails;
  ssrs: Ssr[];
}

export class Ssr {
  ssrCode: string;
  passengersAvailability: PassengersAvailability[];
  ssrType: string;
  name: string;
  limitPerPassenger: number;
  available: number | null;
  inventoryControlled: boolean;
  seatDependent: boolean;
  feeCode: string;
  nest: string;
  seatRestriction: string;
}

export class SsrAvailabilityv2 {
  journeySsrs: JourneySsr[];
  segmentSsrs: SegmentSsr[];
  legSsrs: LegSsr[];
}

export class SSRValue {
  ssrKey: string;
  passengerKey: string;
  price: number;
}




///////////////////////////////////////////////
//jazeera seats
export class Seatobject {
  data: Datum[];
}

export class Datum {
  seatMap: Seatmap;
  fees: Fees;
  ssrLookup: any;
}

export class Seatmap {
  name: string;
  arrivalStation: string;
  departureStation: string;
  equipmentType: string;
  equipmentTypeSuffix: string;
  category: string;
  availableUnits: number;
  decks: Decks;
  seatmapReference: string;
}

export class Decks {
  _1: _1;
}

export class _1 {
  number: number;
  compartments: Compartments;
}

export class Compartments {
  y: Y;
}

export class Y {
  availableUnits: number;
  designator: string;
  length: number;
  width: number;
  sequence: number;
  orientation: number;
  units: Unit[];
}

export class Unit {
  unitKey: string;
  assignable: boolean;
  availability: string;
  compartmentDesignator: string;
  designator: string;
  type: string;
  travelClassCode: string;
  set: number;
  seatStatus: string;
  group: number;
  priority: number;
  setVacancy: number;
  angle: number;
  width: number;
  height: number;
  zone: number;
  x: number;
  y: number;
  allowedSsrs: any[];
  properties: Property1[];
  //text: string;
}

export class Property1 {
  code: string;
  value: string;
}

export class Fees {
  passengerFees: Passengerfee[];
}

export class Passengerfee {
  passengerKey: string;
  groups: Groups;
}

export class Groups {
  _1: _11;
  _2: _2;
  _3: _3;
  _4: _4;
  _5: _5;
}

export class _11 {
  group: number;
  fees: Fee[];
}

export class Fee {
  type: number;
  ssrCode: any;
  ssrNumber: number;
  paymentNumber: number;
  isConfirmed: boolean;
  code: string;
  detail: any;
  passengerFeeKey: string;
  _override: boolean;
  flightReference: string;
  note: any;
  createdDate: string;
  isProtected: boolean;
  serviceCharges: SeatServicecharge[];
}

export class SeatServicecharge {
  amount: number;
  code: string;
  detail: string;
  type: number;
  collectType: number;
  currencyCode: string;
  foreignCurrencyCode: string;
  foreignAmount: number;
  ticketCode: string;
}

export class _2 {
  group: number;
  fees: Fee1[];
}

export class Fee1 {
  type: number;
  ssrCode: any;
  ssrNumber: number;
  paymentNumber: number;
  isConfirmed: boolean;
  code: string;
  detail: any;
  passengerFeeKey: string;
  _override: boolean;
  flightReference: string;
  note: any;
  createdDate: string;
  isProtected: boolean;
  serviceCharges: Servicecharge1[];
}

export class Servicecharge1 {
  amount: number;
  code: string;
  detail: string;
  type: number;
  collectType: number;
  currencyCode: string;
  foreignCurrencyCode: string;
  foreignAmount: number;
  ticketCode: string;
}

export class _3 {
  group: number;
  fees: Fee2[];
}

export class Fee2 {
  type: number;
  ssrCode: any;
  ssrNumber: number;
  paymentNumber: number;
  isConfirmed: boolean;
  code: string;
  detail: any;
  passengerFeeKey: string;
  _override: boolean;
  flightReference: string;
  note: any;
  createdDate: string;
  isProtected: boolean;
  serviceCharges: Servicecharge2[];
}

export class Servicecharge2 {
  amount: number;
  code: string;
  detail: string;
  type: number;
  collectType: number;
  currencyCode: string;
  foreignCurrencyCode: string;
  foreignAmount: number;
  ticketCode: string;
}

export class _4 {
  group: number;
  fees: Fee3[];
}

export class Fee3 {
  type: number;
  ssrCode: any;
  ssrNumber: number;
  paymentNumber: number;
  isConfirmed: boolean;
  code: string;
  detail: any;
  passengerFeeKey: string;
  _override: boolean;
  flightReference: string;
  note: any;
  createdDate: string;
  isProtected: boolean;
  serviceCharges: Servicecharge3[];
}

export class Servicecharge3 {
  amount: number;
  code: string;
  detail: string;
  type: number;
  collectType: number;
  currencyCode: string;
  foreignCurrencyCode: string;
  foreignAmount: number;
  ticketCode: string;
}

export class _5 {
  group: number;
  fees: Fee4[];
}

export class Fee4 {
  type: number;
  ssrCode: any;
  ssrNumber: number;
  paymentNumber: number;
  isConfirmed: boolean;
  code: string;
  detail: any;
  passengerFeeKey: string;
  _override: boolean;
  flightReference: string;
  note: any;
  createdDate: string;
  isProtected: boolean;
  serviceCharges: Servicecharge4[];
}

export class Servicecharge4 {
  amount: number;
  code: string;
  detail: string;
  type: number;
  collectType: number;
  currencyCode: string;
  foreignCurrencyCode: string;
  foreignAmount: number;
  ticketCode: string;
}

